<template>
  <div class="form-item-container" :class="{ 'first-form-item': form_item_order === 0 && layout_mode === 'all_on_one_page' }">
    <div class="questions-container">
      <div class="question-primary-language">
        {{ question_lang1 }}
      </div>
      <div class="question-secondary-language" v-if="bilingue">
        {{ question_lang2 }}
      </div>
    </div>

    <!-- 2 options (1x2 format)-->
    <div v-if="options.length === 2" class="response-container grid-1x2 w-100">
      <div class="option-container no-padding" @click="handleOptionClick(0)" :class="{ 'clicked': clickedOption === 0 }">
      </div>
      <div class="option-container padding" @click="handleOptionClick(1)" :class="{ 'clicked': clickedOption === 1 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[1].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[1].text_lang2 }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 4 options (2x2 format) -->
    <div v-if="options.length === 4" class="response-container grid-2x2 w-100">
      <div class="option-container padding" @click="handleOptionClick(0)" :class="{ 'clicked': clickedOption === 0 }">
        <div class="no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[0].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[0].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(1)" :class="{ 'clicked': clickedOption === 1 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[1].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[1].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(2)" :class="{ 'clicked': clickedOption === 2 }">
        <div class="align-items-center justify no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[2].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[2].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(3)" :class="{ 'clicked': clickedOption === 3 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[3].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[3].text_lang2 }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 6 options (2x3 format) -->
    <div v-if="options.length === 6" class="response-container grid-2x3 w-100">
      <div class="option-container padding" @click="handleOptionClick(0)" :class="{ 'clicked': clickedOption === 0 }">
        <div class="no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[0].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[0].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(1)" :class="{ 'clicked': clickedOption === 1 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[1].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[1].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(2)" :class="{ 'clicked': clickedOption === 2 }">
        <div class="align-items-center justify no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[2].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[2].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(3)" :class="{ 'clicked': clickedOption === 3 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[3].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[3].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(4)" :class="{ 'clicked': clickedOption === 4 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[4].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[4].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(5)" :class="{ 'clicked': clickedOption === 5 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[5].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[5].text_lang2 }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 8 options (2x4 format) -->
    <div v-if="options.length === 8" class="response-container grid-2x4 w-100">
      <div class="option-container padding" @click="handleOptionClick(0)" :class="{ 'clicked': clickedOption === 0 }">
        <div class="no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[0].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[0].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(1)" :class="{ 'clicked': clickedOption === 1 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[1].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[1].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(2)" :class="{ 'clicked': clickedOption === 2 }">
        <div class="align-items-center justify no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[2].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[2].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(3)" :class="{ 'clicked': clickedOption === 3 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[3].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[3].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(4)" :class="{ 'clicked': clickedOption === 4 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[4].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[4].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(5)" :class="{ 'clicked': clickedOption === 5 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[5].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[5].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(6)" :class="{ 'clicked': clickedOption === 6 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[6].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[6].text_lang2 }}</div>
          </div>
        </div>
      </div>
      <div class="option-container padding" @click="handleOptionClick(7)" :class="{ 'clicked': clickedOption === 7 }">
        <div class="align-items-center no-padding display-grid">
          <div class="option-primary-language no-padding">
            <div class="no-padding text-start">{{ options[7].text_lang1 }}</div>
          </div>
          <div v-if="bilingue" class="option-secondary-language">
            <div class="no-padding text-start">{{ options[7].text_lang2 }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { FormItemOption } from '@/utils/DataTypes'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GridItem',
  props: {
    question_lang1: {
      type: String,
      default: ''
    },
    question_lang2: {
      type: String,
      default: ''
    },
    bilingue: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array as () => FormItemOption[],
      default: () => []
    },
    form_item_id: {
      type: Number,
      default: 0
    },
    form_item_order: {
      type: Number,
      default: -1
    },
    layout_mode: {
      type: String,
      default: 'all_on_one_page'
    }
  },
  data() {
    return {
      clickedOption: null as number | null,
      optionsLetter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O']
    }
  },
  methods: {
    handleOptionClick(index: number) {
      this.clickedOption = index
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.option-icon {
  width: 3vw;
  height: 3vw;
}

.form-item-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  padding: 2em 5% 2em 5%;
  color: $gorate-secondary;

  .questions-container {
    grid-row: 1;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    align-items: center;
    justify-items: center;
    padding-bottom: 2em;

    .question-primary-language {
      grid-row: 1;
      font-size: clamp(1.5em, 1vw + 1rem, 2em);
      font-weight: bold;
      padding-bottom: 0.2em;
      text-align: center;
    }

    .question-secondary-language {
      grid-row: 2;
      font-size: clamp(1em, 0.5vw + 1rem, 1.5em);
      text-align: center;
    }
  }

  .response-container {

    .option-container {
      background-color: $gorate-medium;
      color: #000;
      border-radius: 23px;
      border: 4px solid transparent;
      height: 100%;
      display: flex;
      align-items: center;

      .option-primary-language {
        font-size: clamp(1.2em, 1vw + 1rem, 1.5em);
        font-weight: bold;
        text-align: center;
      }

      .option-secondary-language {
        font-size: clamp(1.2em, 0.5vw + 1rem, 1.5em);
        text-align: center;
      }

      &.clicked {
        border: 4px solid $gorate-secondary;
      }
    }
  }

  .grid-1x2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    gap: 1em;
  }

  .grid-2x2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 1rem;
  }

  .grid-2x3 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 1em;
  }

  .grid-2x4 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 1em;
  }
}
</style>
